import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { store } from "./redux/config";
import UserService from "./keycloak/UserService";

const sanitizePathname = () => {
  const sanitizedPath = window.location.pathname.replace(/\0/g, "");
  if (window.location.pathname !== sanitizedPath) {
    const sanitizedURL = `${window.location.origin}${sanitizedPath}${window.location.search}${window.location.hash}`;
    window.location.replace(sanitizedURL);
    return false;
  }
  return true;
};

const root = ReactDOM.createRoot(document.getElementById("root"));

const renderApp = () =>
  root.render(
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  );


if (sanitizePathname()) {
  UserService.initKeycloak(renderApp);
}
